// Import 3rd-party dependencies
import { Component } from '@angular/core';
import { interval } from 'rxjs';
import { map, switchMap, startWith } from 'rxjs/operators';
import moment from 'moment';

// Import project-specific dependencies
import { CalendarEventsService } from '@app/services/calendar-events/calendar-events.service';
import { CALENDAR_EVENTS_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-calendar-events',
  templateUrl: './calendar-events.component.html',
  styleUrls: ['./calendar-events.component.css']
})
export class CalendarEventsComponent {
  consts = CALENDAR_EVENTS_COMPONENT_CONSTS;

  eventsWithInterval$ = interval(this.consts.REFRESH_INTERVAL_SECS).pipe(
    startWith(0),
    switchMap(() => this.events$)
  );

  events$ = this.calendarService.getEmailSettings().pipe(
    switchMap((mailSettings) => {
      const start = moment().utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
      const end = (
        moment().weekday() >= 5
          ? moment().weekday(8) // Show 'Monday' events if the current day is 'Friday'
          : moment().add(1, 'day')
      ).endOf('day').utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
      return this.calendarService.getCalendarEvents(mailSettings.timeZone, start, end);
    }),
    map((events) => {
      const now = moment();
      return events.map((event) => {
        const start = moment(event.start.dateTime);
        const end = moment(event.end.dateTime);
        return {
          subject: event.subject,
          start: start.calendar(this.consts.CALENDAR_CONFIG),
          end:
            start.clone().startOf('day').diff(end.clone().endOf('day'), 'day') < 0
              ? end.calendar(this.consts.CALENDAR_CONFIG)
              : end.format('LT'),
          location: event.location.displayName,
          webUrl: event.webLink,
          joinUrl: event.onlineMeeting?.joinUrl || null,
          showButton:
            start.diff(now, 'minutes') <= this.consts.START_TIME_DIFF_MINS &&
            end.diff(now, 'minutes') > this.consts.END_TIME_DIFF_MINS &&
            event.onlineMeeting != null &&
            !event.isCancelled,
          action: this.consts.BUTTON_JOIN
        };
      });
    })
  );

  constructor(private calendarService: CalendarEventsService) {}

  openLink(url: string): void {
    window.open(url, '_blank');
  }
}
